import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clockdiv position-static bg-transparent p-0 m-0" }
const _hoisted_2 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center gap-3 justify-content-center" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = { class: "days" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "hours" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "minutes" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "seconds" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.days), 1)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.hours), 1)
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.minutes), 1)
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.seconds), 1)
      ])
    ])
  ]))
}